import { render, staticRenderFns } from "./Suggestor.vue?vue&type=template&id=7cc7b1b0&scoped=true"
import script from "./Suggestor.vue?vue&type=script&lang=ts"
export * from "./Suggestor.vue?vue&type=script&lang=ts"
import style0 from "./Suggestor.vue?vue&type=style&index=0&id=7cc7b1b0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc7b1b0",
  null
  
)

export default component.exports